<template>
  <div class="mt-4 px-5">
    <h2>Waffenpool Statistiken</h2>

    <!-- Summary Cards -->
    <v-row class="mt-4" v-if="summary">
      <v-col cols="12" sm="6" md="3">
        <v-card color="primary" dark>
          <v-card-text>
            <div class="text-h4">{{ summary.total_pool_weapons }}</div>
            <div>Gesamt Pool-Waffen</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card color="success" dark>
          <v-card-text>
            <div class="text-h4">{{ summary.active_pool_weapons }}</div>
            <div>Aktive Waffen</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card color="blue" dark>
          <v-card-text>
            <div class="text-h4">{{ summary.club_weapons }}</div>
            <div>Vereinswaffen</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card color="purple" dark>
          <v-card-text>
            <div class="text-h4">{{ summary.user_weapons }}</div>
            <div>Mitgliederwaffen</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Top 5 Waffen -->
    <v-card class="mt-6">
      <v-card-title class="primary white--text">
        <v-icon left color="white">mdi-trophy</v-icon>
        Top 5 genutzte Pool-Waffen
        <v-spacer></v-spacer>
        <v-btn icon dark @click="loadData">
          <v-icon>mdi-reload</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-4">
        <!-- Falls keine Daten -->
        <v-alert
          v-if="topUsedWeapons.length === 0"
          type="info"
          outlined
          dense
        >
          <v-icon left>mdi-information</v-icon>
          Noch keine Pool-Waffen genutzt
        </v-alert>

        <!-- Tabelle mit Daten -->
        <v-simple-table v-else>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Waffe</th>
                <th class="text-right">Nutzungen</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in topUsedWeapons" :key="item.weapon.id">
                <!-- Waffen-Info -->
                <td>
                  <div>
                    <strong>{{ item.weapon.Hersteller }} {{ item.weapon.KurzT }}</strong>
                  </div>
                  <div class="text-caption grey--text">
                    {{ item.weapon.Kaliber }} | {{ item.weapon.Gattung }}
                  </div>
                </td>

                <!-- Nutzungen -->
                <td class="text-right">
                  <v-chip small color="success" dark>
                    <v-icon left small>mdi-chart-line</v-icon>
                    {{ item.usage_count }}x
                  </v-chip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "weaponpoolStatistics",

  computed: {
    comp_Statistics() {
      return this.$store.state.ClubApp.WeaponPoolStatistics || {};
    },

    summary() {
      return this.comp_Statistics.summary || {
        total_pool_weapons: 0,
        active_pool_weapons: 0,
        club_weapons: 0,
        user_weapons: 0
      };
    },

    topUsedWeapons() {
      return this.comp_Statistics.top_used_weapons || [];
    }
  },

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData() {
      await this.$store.dispatch('ClubApp/fetchClubPoolStatistics');
    }
  }
}
</script>
